/**
 * A face-up card, enlarged (opened from the magnifier on a card), with the player's dice right
 * now under it, big. Beginner mode adds its Kill Quest and power with example dice.
 */
import { t, type CardDef, type PublicPlayer } from '@kadice/shared';
import { CardLesson } from '../beginner';
import { cardImage } from '../cards';
import { tx } from '../text';
import { Dice } from './Dice';
import { PName } from './Names';

export function CardZoom({
  player,
  card,
  isYou,
  dice,
  beginner,
  onClose,
}: {
  player: PublicPlayer;
  card: CardDef;
  isYou: boolean;
  /** The player's dice as their seat shows them (held ones coloured). */
  dice: { values: readonly number[]; held: readonly number[] };
  beginner: boolean;
  onClose: () => void;
}) {
  const values = dice.values.filter((v) => v !== 0);
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal card-zoom"
        role="dialog"
        aria-modal="true"
        aria-label={card.name}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="row">
          <h2>
            {isYou
              ? t('zoom.yours', { card: card.name })
              : tx('zoom.theirs', { name: <PName>{player.name}</PName>, card: card.name })}
          </h2>
          <span className="spacer" />
          <button onClick={onClose} aria-label={t('common.close')}>
            ×
          </button>
        </div>
        <div className="card-zoom-body">
          <div className="card-zoom-card">
            <img src={cardImage(player.color, card.id)} alt={card.name} className="card" />
            {values.length > 0 && (
              <div className="card-zoom-dice">
                <Dice values={values} held={dice.held.filter((i) => dice.values[i] !== 0)} />
              </div>
            )}
          </div>
          {beginner && <CardLesson card={card} />}
        </div>
      </div>
    </div>
  );
}
